import React from "react";
import { Page, Text, View, Image } from "@react-pdf/renderer";

import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";
import commonStyles from "../PDFStyles/common";
import styles from "../PDFStyles/ConfidentialityAgreement";
import { getFullName, getFormattedDate } from "../../../util/helpers";
import { getDeclarationPlace } from "../../../util/onBoardingDataFilters";

const ConfidentialityAgreement = React.memo(({ candidateDetails }) => {
  return (
    <Page size="A4" style={commonStyles.page}>
      <Image style={commonStyles.cdkLogo} src={CDK_Logo} />
      <Text
        style={{ ...commonStyles.headerTitleWithUnderline, ...styles.title }}
      >
        Confidentiality Agreement
      </Text>
      <View style={styles.headerinfo}>
        <Text>The Manager</Text>
        <Text>Human Resources</Text>
        <Text>CDK Global (India) Private Limited</Text>
      </View>
      <Text style={styles.mainText}>
        I hereby affirm and acknowledge that I am over the age of eighteen (18)
        and under no legal disability that would prevent me from testifying in
        regard to the matters contained within this agreement. Further, this
        agreement is being made out of my free consent, volition and without
        coercion and undue influence of any kind. I have read and understood
        each and every provisions, and signs it voluntarily and knowingly the
        below agreements;
      </Text>
      <View style={styles.agreementList}>
        <Text>1. Confidential Information</Text>
        <Text>2. Data Privacy : It’s a Matter of Trust</Text>
        <Text>3. Protecting Intellectual Property</Text>
      </View>

      <Text style={styles.agreementText}>
        And I agree to abide by the terms of these agreements
      </Text>
      <View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Signature:</Text>
          <Text style={styles.signatureSignLine}>
            {getFullName(candidateDetails)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Name:</Text>
          <Text style={styles.signatureNameLine}>
            {getFullName(candidateDetails)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Date:</Text>
          <Text style={styles.signatureDateLine}>
            {getFormattedDate(candidateDetails.declarationDate)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Place:</Text>
          <Text style={styles.signaturePlaceLine}>
            {getDeclarationPlace(candidateDetails.declarationPlace)}
          </Text>
        </View>
      </View>
    </Page>
  );
});

export default ConfidentialityAgreement;
